import type { ReactNode } from "react";
import { TrackedSignupLink } from "@/components/tracked-signup-link";

/**
 * A landing-page call-to-action link. When the CTA leads into the signup flow
 * (anonymous visitor → `/get-started` explainer, or directly `/auth/*`), it
 * fires the "Auth Started" funnel event via TrackedSignupLink; for an
 * already-active user (→ `/onboarding`) it's a plain link with no auth event.
 * Gating on `/get-started`/`/auth/` keeps the signup funnel attributed.
 */
export function LandingCta({
  href,
  source,
  className,
  children,
}: {
  href: string;
  source: string;
  className?: string;
  children: ReactNode;
}) {
  if (href.includes("/get-started") || href.includes("/auth/")) {
    return (
      <TrackedSignupLink href={href} intent="signup" source={source} className={className}>
        {children}
      </TrackedSignupLink>
    );
  }
  return (
    <a href={href} className={className}>
      {children}
    </a>
  );
}
